import loadScript from "load-script";

const requests = {};
window.loadedScripts = {};

const CDN_BASE_URL = document.documentElement.dataset.cdnBaseUrl;

export const loadScriptOnce = (url, callback, { silent } = {}) => {
  // If the url is relative, prepend the CDN base url
  if (url.match(/^\/\w+/)) {
    url = `${CDN_BASE_URL}${url}`;
  }

  if (window.loadedScripts[url]) {
    if (callback) callback();
    return;
  }

  // If we are already loading the SDK, add the resolve and reject
  // functions to the existing array of requests
  if (requests[url]) {
    requests[url].push(callback);
    return;
  }

  requests[url] = [callback];

  loadScript(url, error => {
    if (error && !silent) {
      throw new Error(`Could not load Script : ${url}`);
    } else if (error && silent) {
      return console.warn(`Could not load Script : ${url}`);
    }

    window.loadedScripts[url] = true;
    requests[url].forEach(callback => callback && callback());
  });
};

export const loadScriptOnceAsync = async url => {
  return new Promise((resolve, reject) => {
    try {
      loadScriptOnce(url, () => resolve());
    } catch (error) {
      reject(new Error(`Could not load Script : ${url}`));
    }
  });
};
